export default __webpack_public_path__ + "static/media/Activity-documentation.2061f262.md";